import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useAddKeywordRule } from '../../api/addKeywordRule';
import { ChunkPlatform } from '../../utils/chunk-limits';

import { KeywordRuleForm } from './KeywordRuleForm/KeywordRuleForm';

export const AddModal = NiceModal.create(
  ({ pageId, platform }: { pageId: string; platform: ChunkPlatform }) => {
    const modal = useModal();

    const addKeywordRule = useAddKeywordRule({ pageId, config: { onSuccess: modal.hide } });

    return (
      <Modal
        title="Новое правило"
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={modal.remove}
        closeOnEscape={!addKeywordRule.isLoading}
        closeOnClickOutside={!addKeywordRule.isLoading}
        withCloseButton={!addKeywordRule.isLoading}
        scrollAreaComponent={ScrollArea.Autosize}
      >
        {addKeywordRule.isLoading && <Overlay opacity={0} />}
        <KeywordRuleForm
          onSubmit={(data) => addKeywordRule.mutate({ ...data, page: { _id: pageId } })}
          isLoading={addKeywordRule.isLoading}
          platform={platform}
        />
      </Modal>
    );
  }
);
